var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5C5 6.3 4.3 7 3.5 7S2 6.3 2 5.5v-4C2 .7 2.7 0 3.5 0h13c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5S15 6.3 15 5.5V3H5v2.5zM4.5 11.9c-.6.6-.7 1.5-.1 2.1.6.6 1.5.7 2.1.1l2-1.8v6.2c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-6.2l2 1.8c.6.6 1.6.5 2.1-.1.6-.6.5-1.6-.1-2.1L10 7l-5.5 4.9z"
  })));
};
export default SvgUpload;